// extracted by mini-css-extract-plugin
export default {"root":"_2mxLW","link-overlay":"_3Et8k","linkOverlay":"_3Et8k"};